<mat-tab-group [(selectedIndex)]="selectedSubTab" animationDuration="100ms" class="document-subtab-group">
  <mat-tab [label]="'chat.send-file' | translate" *ngIf="hcService.getHcConfig().mealPlan?.enableSendFiles">
    <app-session-details-patient-upload-files></app-session-details-patient-upload-files>
  </mat-tab>

  <mat-tab
    [label]="'actions.create-document' | translate"
    *ngIf="hcService.getHcConfig().mealPlan?.enableDocumentCreation"
  >
    <app-session-details-patient-create-document></app-session-details-patient-create-document>
  </mat-tab>
</mat-tab-group>
